import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import store from './redux/Store';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Spinner from './views/spinner/Spinner';

import { SnackbarProvider } from 'notistack';
import { AlertSnackbar } from './components/common/AlertSnackbar';

// Comprehensive ResizeObserver error suppression
const isResizeObserverError = (error) => {
  const message = error?.message || error?.reason?.message || error?.error?.message || String(error);
  return (
    message.includes('ResizeObserver loop completed with undelivered notifications') ||
    message.includes('ResizeObserver loop limit exceeded') ||
    message.includes('ResizeObserver')
  );
};

const resizeObserverErrorHandler = (e) => {
  if (isResizeObserverError(e)) {
    e.preventDefault?.();
    e.stopPropagation?.();
    return false;
  }
  // Log other errors normally
  console.error(e);
};

const unhandledRejectionHandler = (event) => {
  if (isResizeObserverError(event.reason || event)) {
    event.preventDefault?.();
    return false;
  }
  // Log other rejection errors normally
  console.error('Unhandled promise rejection:', event.reason);
};

// Add multiple event listeners to catch all error types
window.addEventListener('error', resizeObserverErrorHandler);
window.addEventListener('unhandledrejection', unhandledRejectionHandler);

// Also override console.error temporarily to filter ResizeObserver errors
const originalConsoleError = console.error;
console.error = (...args) => {
  const message = args.join(' ');
  if (isResizeObserverError({ message })) {
    return; // Suppress ResizeObserver errors from console
  }
  originalConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      Components={{
        success: AlertSnackbar,
        error: AlertSnackbar,
        warning: AlertSnackbar,
        info: AlertSnackbar,
      }}
    >
      <Suspense fallback={<Spinner />}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Suspense>
    </SnackbarProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
